import { cn } from 'src/lib/utils';

type CheckboxState = 'checked' | 'unchecked' | 'indeterminate';

interface SelectionCheckboxProps {
  state: CheckboxState;
  disabled?: boolean;
  onClick?: () => void;
}

export function SelectionCheckbox({
  state,
  disabled = false,
  onClick,
}: SelectionCheckboxProps) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={state === 'indeterminate' ? 'mixed' : state === 'checked'}
      disabled={disabled}
      className={cn(
        'flex size-[18px] shrink-0 items-center justify-center rounded border-[1.5px] text-[12px] font-bold leading-none text-white',
        state === 'unchecked'
          ? 'border-[#D9DBE3] bg-white'
          : 'border-[#2563EB] bg-[#2563EB]',
        disabled && 'cursor-not-allowed opacity-50'
      )}
      onClick={(event) => {
        event.stopPropagation();
        if (!disabled) {
          onClick?.();
        }
      }}
    >
      {state === 'checked' ? '✓' : state === 'indeterminate' ? '–' : ''}
    </button>
  );
}
